import { Card } from "@/components/ui/card";
import { usd, fmtDate, StatusPill } from "./affiliateFormat";

const PLAN_LABELS = { premium_monthly: "Monthly", premium_yearly: "Yearly", founding_artist: "Founding Artist" };

export const CommissionList = ({ rows }) => (
  <Card className="bg-black/40 border border-white/10 p-5" data-testid="affiliate-commissions">
    <h3 className="text-white font-bold mb-3">Commissions</h3>
    {rows.length === 0 ? (
      <p className="text-sm text-gray-500" data-testid="affiliate-commissions-empty">No paid conversions yet.</p>
    ) : (
      <div className="divide-y divide-white/5">
        {rows.map((c) => (
          <div key={c.commission_id} className="py-2.5 flex items-center justify-between gap-3 text-sm" data-testid={`affiliate-commission-${c.commission_id}`}>
            <div>
              <p className="text-white">{PLAN_LABELS[c.plan_id] || c.plan_id} membership</p>
              <p className="text-[11px] text-gray-500">
                Paid {fmtDate(c.paid_at)} · {c.status === "pending" ? `available ${fmtDate(c.hold_until)}` : `net ${usd(c.net_cents)}`}
              </p>
            </div>
            <div className="flex items-center gap-2">
              <span className="font-bold text-white">{usd(c.amount_cents)}</span>
              <StatusPill status={c.status} />
            </div>
          </div>
        ))}
      </div>
    )}
  </Card>
);

export const PayoutList = ({ rows }) => (
  <Card className="bg-black/40 border border-white/10 p-5" data-testid="affiliate-payouts">
    <h3 className="text-white font-bold mb-3">Payout history</h3>
    {rows.length === 0 ? (
      <p className="text-sm text-gray-500" data-testid="affiliate-payouts-empty">No payout requests yet.</p>
    ) : (
      <div className="divide-y divide-white/5">
        {rows.map((p) => (
          <div key={p.payout_id} className="py-2.5 flex items-center justify-between text-sm" data-testid={`affiliate-payout-${p.payout_id}`}>
            <div>
              <p className="text-white">{usd(p.amount_cents)}</p>
              <p className="text-[11px] text-gray-500">Requested {fmtDate(p.requested_at)}{p.paid_at ? ` · paid ${fmtDate(p.paid_at)}` : ""}</p>
            </div>
            <StatusPill status={p.status} />
          </div>
        ))}
      </div>
    )}
  </Card>
);
